import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from "react-redux";
import iconBuy from '../../assets/icons/ico-buy.png';
import iconSell from '../../assets/icons/ico-sell.png';
import iconYen from '../../assets/icons/ico-yen.svg';
import iconLoop from '../../assets/icons/ico-loop.svg';
import { setLifeEventSelected, showSelectedModel } from '../../redux/lifePlan';
import { getEventMapping, convertCurrency } from '../../shared/constants/global';

export default function Event(props) {
  const dispatch = useDispatch()
  const cycleEvent = useSelector(state => state.cycleEvent);
  const numberOfPeople = useSelector(state => state.life_plan.number_of_people);

  const handleOpenModal = () => {
    dispatch(setLifeEventSelected(props.event))
    dispatch(showSelectedModel())
  }

  const [eventMapping, setEventMapping] = useState(getEventMapping(props.event))
  const [amount, setAmount] = useState(eventMapping.getAmount(props.event))
  const [eventTitle, setEventTitle] = useState(eventMapping.getEventTitle(props.event))
  const isLoop = cycleEvent.findIndex(e => e.uuid == props.event.uuid) != -1

  const cycleEventGetAmount = (event) => {
    if (props.event.isClone && ![5, 6, 7].includes(event.event_type)) {
      return convertCurrency(eventMapping.getCycleAmount(event))
    } else if (event.event_type == 5) {
      return convertCurrency((+eventMapping.getAmount(event) + +eventMapping.getCycleAmount(event)) * (numberOfPeople || 1))
    } else {
      return convertCurrency((+eventMapping.getAmount(event) + +eventMapping.getCycleAmount(event)) * (event.other?.number_of_people || 1))
    }
  }

  const getEventName = (event) => {
    if (event.custom) return event.custom

    return eventMapping.name
  }

  useEffect(() => {
    setEventMapping(getEventMapping(props.event))
    setAmount(cycleEventGetAmount(props.event))
    setEventTitle(eventMapping.getEventTitle(props.event))
  }, [props.event])

  return (
    <React.Fragment>
      <div className="timelineEvent" onClick={handleOpenModal}>
        <div className="eventImageContainer">
          { eventMapping.is_buy && <img src={iconBuy} alt="BUY" className="ico" /> }
          { eventMapping.is_sell && <img src={iconSell} alt="SELL" className="ico" /> }
          <div className="eventImage" style={{"backgroundImage": `url(${require("images/lps-" + getEventMapping(props.event).type_name + ".png")})`}} />
        </div>
        <div className="eventTitle"><span>{eventTitle || getEventName(props.event)}</span></div>
        <div className="eventAmount">
          { (amount || amount == 0) && <React.Fragment><img src={iconYen} alt=""/><div dangerouslySetInnerHTML={{__html: amount}} /></React.Fragment> }
        </div>
        <div className="eventLoop">
          { isLoop && <React.Fragment><img src={iconLoop} alt=""/><div>{props.event.other.frequency_year || 1}年に1回</div></React.Fragment> }
        </div>
      </div>
    </React.Fragment>
  )
}
